import Menu from '@mui/material/Menu';
import MenuItem, { MenuInterface } from './MenuItem';

interface MenuConfigTypes {
  listMenu?: MenuInterface[];
  anchorEl: null | HTMLElement;
  handleMenuClose: () => void;
}

const MenuConfig = (props: MenuConfigTypes) => {

  const open = Boolean(props.anchorEl);

  return (
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={props.anchorEl}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        open={open}
        PaperProps={{
          style: {
            maxHeight: "220px",
            minWidth: '96px',   
            zIndex: 1001,
            border:"2px solid #00000014", borderRadius:"4px",
            boxShadow: "2px 5px 14px #00000012",
            marginRight:"20px"               
          },
        }}

        onClose={props.handleMenuClose}
      >
        <MenuItem listMenuInterface={props.listMenu!}/>    
      </Menu>
  );
}

export default MenuConfig;